import { useContext, useState } from "react";
import { OrderDetailItem, OrderSplitResultItem } from "../../interfaces/interfaces";
import { sortProducts } from "../../pages/order-uploader/utils/productUtils";
import CartItem from "../CartItem/CartItem";
import IconButton from "../IconButton/IconButton";
import { StyledButton } from "../styled/styled-components";
import { Context, IContext } from "../../context/ContextApp";
import Icon from "../Icon/icon";
import Tooltip from "../Tooltip/Tooltip";
import { FetchedOrderUploadProduct } from "../../pages/order-uploader/types";

interface Props {
  items: OrderSplitResultItem[] | OrderDetailItem[] | FetchedOrderUploadProduct[];
  action?: boolean;
  showStock?: boolean;
  showIndex?: boolean;
  checkout?: boolean;
  bo?: boolean;
  split?: boolean;
  disableAvailableQty?: boolean;
  disableTotal?: boolean;
}

interface Sort {
  ascending: boolean;
  type: "index" | "stock" | "b/o" | "none";
}

const CartItemTable = (props: Props) => {
  const {
    items,
    action,
    showStock,
    showIndex,
    checkout,
    bo,
    split,
    disableAvailableQty = false,
    disableTotal = false,
  } = props;
  const [sort, setSort] = useState<Sort>({
    ascending: true,
    type: "none",
  });
  const { appBranch }: IContext = useContext(Context);

  if (items && items.length > 0) {
    const sortedItems = sortProducts(items.slice() as FetchedOrderUploadProduct[], sort);

    return (
      <>
        {(bo || showStock) && (
          <StyledButton onClick={() => setSort({ ascending: true, type: "none" })}>
            Sort by original order
          </StyledButton>
        )}
        <table className="cart-item-table">
          <tbody>
            <tr>
              {showIndex && <th>Line</th>}
              <th className="description">Description</th>
              <th>Colour</th>
              <th>Size</th>
              {checkout && appBranch === "au" && (
                <>
                  <th style={{ backgroundColor: "rgb(0, 196, 245)" }}>SYD</th>
                  <th style={{ backgroundColor: "rgb(233, 67, 64)" }}>MEL</th>
                  <th style={{ backgroundColor: "rgb(0, 166, 97)" }}>PER</th>
                </>
              )}
              <th>Reference</th>
              {["au", "nz"].includes(appBranch) ? (
                <>
                  <th>Order Qty</th>
                  {!disableAvailableQty && (
                    <th>
                      <Tooltip
                        content="Units currently in stock and ready to ship. Used to calculate the Total."
                        tooltipClassName="tooltip"
                      >
                        Available Qty
                      </Tooltip>
                    </th>
                  )}
                </>
              ) : (
                <th>Qty</th>
              )}
              {bo && (
                <th style={{ backgroundColor: "rgb(37,52,57)", color: "white" }}>
                  B/O
                  <IconButton
                    inline
                    style={{ marginLeft: "1em" }}
                    onClick={() => setSort({ ascending: !sort.ascending, type: "b/o" })}
                  >
                    {sort.ascending ? <Icon name="ArrowUp" /> : <Icon name="ArrowDown" />}
                  </IconButton>
                </th>
              )}
              {showStock && (
                <th>
                  Available Stock
                  <IconButton
                    inline
                    style={{ marginLeft: "1em" }}
                    onClick={() => setSort({ ascending: !sort.ascending, type: "stock" })}
                  >
                    {sort.ascending ? <Icon name="ArrowUp" /> : <Icon name="ArrowDown" />}
                  </IconButton>
                </th>
              )}
              <th>Price</th>
              {!disableTotal && <th>Total</th>}
              {action && <th />}
            </tr>
            {sortedItems.map((product, index) => (
              <CartItem
                key={index}
                item={product}
                action={action}
                bo={bo}
                split={split}
                showStock={showStock}
                disableAvailableQty={disableAvailableQty}
                disableTotal={disableTotal}
                index={showIndex && product.index && `${parseInt(product.index) + 1}`}
              />
            ))}
          </tbody>
        </table>
      </>
    );
  } else return <></>;
};

export default CartItemTable;
